/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductVariantsQueryResponse, GetShowProductVariantsPathParams, GetShowProductVariantsQueryParams, GetShowProductVariants404 } from "../../models/GetShowProductVariants";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductVariantsUrl({ productCode }: { productCode: GetShowProductVariantsPathParams["productCode"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${productCode}/variants` as const }  
  return res
}

/**
 * {@link /api/v1/products/:productCode/variants}
 */
export async function getShowProductVariants({ productCode, params }: { productCode: GetShowProductVariantsPathParams["productCode"]; params: GetShowProductVariantsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductVariantsQueryResponse, ResponseErrorConfig<GetShowProductVariants404>, unknown>({ method : "GET", url : getGetShowProductVariantsUrl({ productCode }).url.toString(), params, ... requestConfig })  
  return res.data
}